(function () {
	"use strict";

	angular.module("sempraWebapp").component("weatherHistoryChart", {
		templateUrl:
			"app/components/weatherHistoryChart/weatherHistoryChart.html",
		controller: weatherHistoryChartController,
		bindings: {
			weatherData: "<",
			locationData: "<"
		},
		controllerAs: "vm"
	});

	function weatherHistoryChartController() {
		var vm = this;

		vm.$onInit = function () {};

		vm.$onChanges = function () {};

		vm.$onDestroy = function () {};
	}
})();
